/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { JobCategoryApi } from '../api/jobcategory.api';
import { switchMap, map } from 'rxjs/operators';
import { JobCategoryData, JobCategory } from '../../../interfaces/masters/jobCategory';

@Injectable()
export class JobCategoryService extends JobCategoryData {

  constructor(private api: JobCategoryApi) {
    super();
  }


  list(url: string): Observable<JobCategory[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<JobCategory>{
      return this.api.getById(url);
  }

//   create(url: string, data:Payers): Observable<Payers> {
//     return this.api.add(url,data);
//   }

//   update(url: string, data:Payers): Observable<Payers> {
//     return this.api.update(url,data);
//   }

  

//   delete(url: string): Observable<boolean> {
//     return this.api.delete(url);
//   }
}
